<template>
  <div class="fl ovf-auto" v-scroll="onScroll" :style="'width:' + width + ';height:' + height" @mousemove="dragMove($event)">
    <div class="ele-list w-100" @mouseup="dragUp($event, false)">
      <div
        class="ele"
        v-for="(item, index) in eleList"
        :class="{
          'active': curEle.type == item.type && item.type == TYPE_ROUTE
        }"
        @mousedown="dragDown($event, item, 'add')">
        <div
          :class="getNodeClass(item.type)"></div>
        <span>{{item.name}}</span>
      </div>
    </div>
    <div class="paper-wrapper pos-rel" :style="paperSize">
      <div class="del-route" v-show="delRouteBtn.show" :style="delRouteBtn.pos">
        <span @click="deleteRoute">×</span>
      </div>
      <svg class="route-paper" @mousedown="resetRoute">
        <defs>
          <marker id="arrow1" viewBox="0 0 6 6" refX="5" refY="3" markerUnits="strokeWidth" markerWidth="6" markerHeight="6" orient="auto">
            <path d="M 0 0 L 6 3 L 0 6 z" fill="#0080d3" stroke-width="0"></path>
          </marker>
          <marker id="arrow2" viewBox="0 0 6 6" refX="5" refY="3" markerUnits="strokeWidth" markerWidth="6" markerHeight="6" orient="auto">
            <path d="M 0 0 L 6 3 L 0 6 z" fill="#ff3300" stroke-width="0"></path>
          </marker>
        </defs>
        <g from="" to="" style="cursor: pointer;">
          <path visibility="hidden" stroke-width="9" fill="none" stroke="white"  d="M 126 93 L 563 166" pointer-events="stroke"></path>
          <path :d="tempRoute.path" stroke-width="1.4" stroke-linecap="round" fill="none" style="stroke-dasharray:6,5" stroke="#ff3300" marker-end="url(#arrow2)"></path>
        </g>
        <g from="" to="" style="cursor: pointer;" v-for="(route, index) in routeList" @click="selectRoute($event, index, route)">
          <template v-if="curRouteIndex == index">
            <path visibility="hidden" stroke-width="20" fill="none" stroke="white" :d="route.path" pointer-events="stroke"></path>
            <path :d="route.path" stroke-width="1.4" stroke-linecap="round" fill="none" stroke="#ff3300" marker-end="url(#arrow2)"></path>
          </template>
          <template v-else>
            <path visibility="hidden" stroke-width="20" fill="none" stroke="white" :d="route.path" pointer-events="stroke"></path>
            <path :d="route.path" stroke-width="1.4" stroke-linecap="round" fill="none" stroke="#0080d3" marker-end="url(#arrow1)"></path>
          </template>
          <text text-anchor="middle" :x="(route.start_x + route.end_x) / 2" :y="(route.start_y + route.end_y) / 2" fill="black" style="cursor: text;">{{ route.remark }}</text>
        </g>
      </svg>
      <div class="draw-paper h-100p" @mouseup="dragUp($event, true)">
        <div class="draw-node" 
            v-for="(item, index) in nodeList" 
            :class="[getNodeClass(item.type), {
              'crosshair': curEle.type == TYPE_ROUTE,
              'active': curNode.iden == item.iden
            }]"
            :style="[item.pos, item.size]"
            @mousedown="dragDown($event, item, 'move')"
            @mouseup="dragUp($event, true, item)"
            @click="selectNode(item)"
            @dblclick="dbclickEvent">
          <span class="del-node" @mousedown="confirmDeleteNode($event, item, index)" v-if="item.type != 10">×</span>
          <span class="node-name text-overflow" @dblclick="editRemark">{{item.name}}</span>
          <input type="text" v-model="item.name" v-show="item.edit">
          <span class="resizer" @mousedown="dragDown($event, item, 'resize')"></span>
        </div>
        <div 
          class="draw-node temp-node" 
          :class="getNodeClass(tempNode.type)"
          :style="tempNode.pos">
          <span class="node-name">{{tempNode.name}}</span>
        </div>
      </div>
    </div>
    <!-- 删除节点弹窗提示 -->
    <el-dialog title="提示" v-model="delShow" size="tiny">
      <span>是否删除该节点？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteNode">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style>
  /*左侧选择栏*/
  .paper-wrapper {
    min-width: 1000px;
    min-height: 700px;
  }
  .ele-list {
    position: fixed;
    max-height: 570px;
    background-color: #f8f8f8;
    box-shadow: 1px 1px 3px #ccc;
    overflow-y: auto;
    z-index: 2;
  }
  .ele {
    border-bottom: 1px solid #e5e5e5;
    height: 70px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }
  .ele:last-child {
    border-bottom: none
  }
  .ele.active {
    background-color: #ddd;
  }
  .ele > div {
    margin-top: 5px;
    margin-bottom: 5px;
    margin: 0 auto;
    height: 45px !important;
    background-image: url(../../../assets/images/flow.png);
  }
  .ele .route {
    width: 36px;
    background-position: -60px 15px;
    background-size: 650px 244px;
  }
  .ele .mission {
    width: 41px;
    background-position: -127px -54px;
    background-size: 650px 244px;
  }
  .ele .func {
    width: 41px;
    background-position: -468px -54px;
    background-size: 650px 244px;
  }
  .ele .cud {
    width: 41px;
    background-position: -594px -54px;
    background-size: 650px 244px;
  }
  .ele .approve {
    width: 41px;
    background-position: -192px -54px;
    background-size: 650px 244px;
  }
  .ele .only {
    width: 41px;
    background-position: 0 -54px;
    background-size: 650px 244px;
  }
  .ele .multiple {
    width: 41px;
    background-position: -66px -54px;
    background-size: 650px 244px;
  }
  .ele .emit {
    width: 34px;
    background-position: -244px 10px;
    background-size: 650px 244px;
  }
  .ele .end {
    width: 34px;
    background-position: -365px 10px;
    background-size: 650px 244px;
  }
  .ele .remark {
    width: 52px;
    background-position: -410px 10px;
    background-size: 650px 244px;
  }
  /*左侧选择栏*/
  .draw-paper {
    background-color: #eee;
    background-image: url(../../../assets/images/grid.png)
  }
  .route-paper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .crosshair {
    cursor: crosshair !important;
  }
  .draw-node {
    position: absolute;
    margin: 0 auto;
    min-width: 80px;
    min-height: 80px;
    color: #fff;
    text-align: center;
    cursor: move;
    box-sizing: border-box;
  }
  .draw-node.mission,
  .draw-node.approve {
    width: 100px;
    height: 64px;
    min-width: 64px;
    min-height: 64px;
    border-radius: 5px;
    background-color: #0080d3;
  }
  .draw-node.only,
  .draw-node.multiple {
    width: 103px;
    height: 90px;
  }
  .draw-node.only:after,
  .draw-node.multiple:after {
    display: inline-block;
    position: absolute;
    top: 13%;
    left: 16%;
    width: -moz-calc((100% - 10px)/1.6);
    width: -webkit-calc((100% - 10px)/1.6);
    width: calc((100% - 10px)/1.6);
    height: -moz-calc((100% - 12px)/1.4);
    height: -webkit-calc((100% - 12px)/1.4);
    height: calc((100% - 12px)/1.4);
    background-color: #0080d3;
    content: ' ';
    box-sizing: content-box;
    transform: rotateZ(-45deg) skew(5deg, 5deg);
    -ms-transform: rotateZ(-45deg) skew(5deg, 5deg);
    -moz-transform: rotateZ(-45deg) skew(5deg, 5deg);
    -webkit-transform: rotateZ(-45deg) skew(5deg, 5deg);
    -o-transform: rotateZ(-45deg) skew(5deg, 5deg);
  }
  .draw-node.only:after,
  .draw-node.multiple:after {
    border: 5px solid #fff;
  }
  .draw-node.only:before,
  .draw-node.multiple:before,
  .draw-node.func:before,
  .draw-node.cud:before,
  .draw-node.mission:before,
  .draw-node.approve:before {
    position: absolute;
    bottom: 20%;
    left: 50%;
    margin-left: -15px;
    width: 30px;
    height: 18px;
    background-image: url(../../../assets/images/flow.png);
    background-size: 650px 244px;
    z-index: 1;
    content: ' ';
  }
  .draw-node.only:before {
    background-position: -298px -54px;
  }
  .draw-node.multiple:before {
    background-position: -329px -54px;
  }
  .draw-node.mission:before {
    bottom: 10%;
    background-position: -358px -54px;
  }
  .draw-node.approve:before {
    bottom: 10%;
    background-position: -395px -54px;
  }
  .draw-node.func:before {
    bottom: 10%;
    background-position: -426px -54px;
  }
  .draw-node.cud:before {
    bottom: 10%;
    background-position: -538px -54px;
  }

  .draw-node.start,
  .draw-node.func,
  .draw-node.cud,
  .draw-node.end {
    width: 90px;
    height: 90px;
    border-radius: 100%;
    background-color: #0080d3;
  }
  .draw-node.start,
  .draw-node.cud {
    border: 5px solid #fff;
  }
  .draw-node.func,
  .draw-node.end {
    border: 5px solid #005f9d;
  }
  .temp-node {
    opacity: .5;
  }
  .draw-node span.node-name {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    max-height: 80%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    font-size: 14px;
    z-index: 1;
  }
  .draw-node.active span.node-name {
    color: #13ce66
  }
  .draw-node span.resizer {
    position: absolute;
    bottom: 0;
    right: 0;
    border-left: 20px solid transparent;
    border-top: 20px solid transparent;
    border-right: 20px solid rgba(0, 0, 0, .8);
    background-color: transparent;
    cursor: se-resize;
    z-index: 0;
  }
  .draw-node .del-node {
    position: absolute;
    top: 10px;
    right: 5px;
    line-height: 0;
    font-weight: bold;
    font-size: 18px;
    color: #000;
    cursor: pointer;
  }
  .draw-node.remark {
    width: 150px;
    height: 64px;
    padding: 10px;
    line-height: 16px !important;
  }
  .draw-node.remark .node-name{
    color: #000 !important;
  }
  .del-route {
    position: absolute;
    top: 200px;
    left: 200px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border: 3px solid #0080d3;
    border-radius: 100%;
    text-align: center;
    cursor: pointer;
    z-index: 1;
  }
  .del-route span {
    color: #0080d3;
    font-size: 28px;
  }
  .max-w-120 {
    max-width: 120px;
  }
  .flow .temp-drag,
  .flow .temp-sort {
    z-index: -1;
  }
  /* 执行函数 */
  
</style>

<script>
  /**
   * author duoremix
   * @param String height 高度
   * @param String width 宽度
   * @param Object curNode 当前选中节点
   * @param Object curRoute 当前选中路由
   * @param Array nodeList 节点列表
   * @param Array routeList 路由列表
   * @param Array inputList 控件列表
   * @param Number nodeIden 当前节点唯一标识
   * @param Object inputTitle 以id为key的控件标题数据（对象）
   * @param Object inputType 以id为key的控件类型数据（对象）
   */
  import flowConfig from '../../../config/flowConfig'
  import modelConfig from '../../../config/modelConfig'
  export default {
    props: ['height', 'width', 'curNode', 'curRoute', 'nodeList', 'routeList', 'inputList', 'nodeIden', 'inputTitle', 'inputType'],
    data() {
      return {
        COMPONENT_NAME: 'nodePaper',
        paperSize: {
          width: '5000px',
          height: '5000px'
        },
        eleList: [
          { name: '顺序流', type: 100 },
          { name: '任务', type: 20 },
          { name: '审批', type: 30 },
          { name: '排他网关', type: 40 },
          { name: '并行网关', type: 50 },
          { name: '执行函数', type: 80 },
          { name: 'CUD', type: 90 },
          { name: '结束', type: 60 },
          { name: '文本备注', type: 70 }
        ],
        isDrag: false,  // 拖拽标识
        dragType: '',
        curEle: {},  // 当前拖拽类型的节点
        curRouteIndex: -1, // 当前选中路由的索引
        curVar: {}, // 当前配置的判断变量
        tempNode: {}, // 添加时拖拽的临时节点
        tempRoute: {}, // 临时路由
        elePos: {},  // 用于检测元素是否被拖动，防滑
        offsetX: 20,  // 画布较窗口偏移x值
        offsetY: 80,  // 画布较窗口偏移y值
        defaultSize: [
          { width: 90, height: 90 }, // type:10 开始
          { width: 100, height: 64 }, // type:20 任务
          { width: 100, height: 64 }, // type:30 审批
          { width: 103, height: 90 }, // type:40 排他
          { width: 103, height: 90 }, // type:50 并行
          { width: 90, height: 90 }, // type:60 结束
          { width: 150, height: 64 }, // type:70 文本备注
          { width: 90, height: 90 }, // type:80 执行函数
          { width: 90, height: 90 } // type:90 CUD
        ],
        scrollOfs: { // 滚动条偏移值
          scrollTop: 0,
          scrollLeft: 0
        },
        resizePos: { // 缩放的起始点
          posX: 0,
          posY: 0
        },
        sourceSize: { // 缩放前的大小
          width: 0,
          height: 0
        },
        delRouteBtn: { // 删除路由的按钮显示与位置
          show: false,
          pos: {}
        },
        delNode: {}, // 删除的节点
        delShow: false, // 显示删除节点弹窗
        inputListShow: false,
        connectStartNode: {}
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        document.addEventListener('mouseup', () => {
          // 拖拽、路由绘制取消
          this.isDrag = false
          this.tempRoute = {}
          this.delRouteBtn.show = false
        })
      },
      onScroll(event, position) {
        this.scrollOfs = position
      },
      resetRoute() {
        this.curRouteIndex = -1
        this.$emit('setCurRoute', {})
      },
      // 获取节点的类名
      getNodeClass(type) {
        let className = ''
        switch (type) {
          case this.TYPE_MISSION: // 任务
            className = 'mission'
            break
          case this.TYPE_APPROVE: // 审批
            className = 'approve'
            break
          case this.TYPE_ONLY: // 排他
            className = 'only'
            break
          case this.TYPE_MULTIPLE: // 并行
            className = 'multiple'
            break
          case this.TYPE_FUNC: // 执行行数
            className = 'func'
            break
          case this.TYPE_CUD: // CUD
            className = 'cud'
            break
          case this.TYPE_START: // 开始
            className = 'start'
            break
          case this.TYPE_END: // 结束
            className = 'end'
            break
          case this.TYPE_REMARK: // 备注
            className = 'remark'
            break
          case this.TYPE_ROUTE: // 路由
            className = 'route'
            break
        }
        return className
      },
      // 鼠标点下时：判断连接路由、添加节点、移动节点、是否缩放节点（优先级从左到右）
      dragDown(event, item, dragType) {
        event.stopPropagation()
        this.isDrag = true
        if (this.curEle.type == 100 && dragType == 'move') {
          // 选择类型为路由且点击节点，则设置拖拽类型为连接路由
          dragType = 'connect'
        }
        this.dragType = dragType
        if (dragType == 'add') {
          // 拖拽添加
          this.curEle = item
        } else if (dragType == 'move') {
          this.moveDown(event, item)
        } else if (dragType == 'connect') {
          this.connectDown(event, item)
        } else if (dragType == 'resize') {
          this.resizeDown(event, item)
        }
      },
      // 移动节点时获取当前节点
      moveDown(event, item) {
        // console.log('移动节点时获取当前节点', event)
        // console.log('移动节点时获取当前节点', item)
        this.$emit('setCurNode', item)
        this.elePos = {
          posX: event.pageX,
          posY: event.pageY
        }
      },
      // 连接路由时获取当前节点并创建临时路由
      connectDown(event, item) {
        this.connectStartNode = item
        let startX = event.pageX - this.offsetX + this.scrollOfs.scrollLeft
        let startY = event.pageY - this.offsetY + this.scrollOfs.scrollTop
        this.tempRoute = {
          start_x: startX,
          start_y: startY,
          path: `M ${startX} ${startY} T ${startX} ${startY}`,
          start_iden: item.iden,
          end_iden: ''
        }
      },
      // 缩放节点点击鼠标时获取原始位置
      resizeDown(event, item) {
        this.$emit('setCurNode', item)
        this.resizePos = {
          posX: event.pageX,
          posY: event.pageY
        }
        this.sourceSize = {
          width: parseInt(item.size.width),
          height: parseInt(item.size.height)
        }
      },
      // 鼠标移动时：判断是否缩放节点、连接路由、添加节点、移动节点（优先级从左到右）
      dragMove(event) {
        if (!this.isDrag) {
          return
        }
        if (this.dragType == 'resize') {
          this.resizeMove(event)
          this.redrawRoute()
        } else if (this.curEle.type && this.curEle.type != 100) {
          // 添加节点
          this.addNodeMove(event)
        } else if (this.curEle.type == 100) {
          // 连接路由
          this.connectMove(event)
        } else if (this.curNode.type) {
          // 移动节点
          this.moveNodeMove(event)
          this.redrawRoute()
        }
      },
      // 缩放节点移动鼠标时重新计算节点尺寸
      resizeMove(event) {
        let width = 0
        let height = 0
        if (this.curNode.type == this.TYPE_MISSION ||
            this.curNode.type == this.TYPE_APPROVE ||
            this.curNode.type == this.TYPE_REMARK) { // 任务节点和文本描述不需按比例缩放，最小尺寸为64*64
          width = this.sourceSize.width + event.pageX - this.resizePos.posX
          height = this.sourceSize.height + event.pageY - this.resizePos.posY
          width = width >= 64 ? width : 64
          height = height >= 64 ? height : 64
        } else { // 其余需按比例缩放，最小尺寸为80*80
          width = this.sourceSize.width + event.pageX - this.resizePos.posX
          height = this.sourceSize.height + event.pageX - this.resizePos.posX
          width = width >= 80 ? width : 80
          height = height >= 80 ? height : 80
        }
        this.curNode.size = {
          width: width + 'px',
          height: height + 'px'
        }
      },
      // 添加节点移动鼠标时移动临时节点
      addNodeMove(event) {
        if (!this.tempNode.type) {
          this.tempNode = {
            name: `节点${this.nodeIden}`,
            type: this.curEle.type,
            pos: {},
            size: {},
            receive_user: { // 接收人类型
              back_higher_status: 0,
              founder_higher_status: 0,
              founder_status: 0,
              free_status: 0
            },
            pass_dialog_config: {  // 审批弹窗字段
              title: '审批意见',
              placeholder: '同意',
              allowEmpty: 0
            },
            rollback_dialog_config: {  // 回退弹窗字段
              title: '审批意见',
              placeholder: '不同意',
              allowEmpty: 0
            },
            present_type: 10, // 接收类型
            rollback_config: 10, // 回退人配置
            user_ids: [], // 自定义接收人
            group_ids: [], // 用户组
            struct_ids: [], // 接收部门
            post_ids: [], // 接收岗位
            examine_rule: 10, // 审批规则
            connect_type: 10, // 连接类型
            variable: [], // 变量判断网关
            field: [], // 关联控件列表
            examine_iden: '',
            examine: [],
            functions: {
              function_name: '',
              package_name: '',
              params: [],
              return_params: []
            }, // 执行函数
            cud_config: [], // cud配置
            notify_config: {  // 知会消息接收人配置
              receive_user: { // 接收人配置
                back_higher_status: 0, // 上一级处理人上级
                founder_higher_status: 0, // 发起人上级
                founder_status: 0,      // 发起人
                free_status: 0,         // 自定义配置
                related_field_status: 0 // 关联字段配置
              },
              related_field_config: {
                field_id: '',
                related_field_id: ''
              },
              present_type: 0,
              user_ids: [],   // 选中用户id
              group_ids: [], // 选中用户组id
              struct_ids: [],  // 选中的部门id
              is_reset_notify: 0,  // 是否重置消息通知
              msg_title: 0,        // 消息标题
              msg_content: 0       // 消息内容
            }
          }
        }
        this.tempNode.pos = {
          left: event.pageX - this.defaultSize[this.curEle.type / 10 - 1].width / 2 - this.offsetX + this.scrollOfs.scrollLeft + 'px',
          top: event.pageY - this.defaultSize[this.curEle.type / 10 - 1].height / 2 - this.offsetY + this.scrollOfs.scrollTop + 'px'
        }
      },
      // 连接路由移动鼠标时绘制临时路由路径
      connectMove(event) {
        let startX = this.tempRoute.start_x
        let startY = this.tempRoute.start_y
        let endX = event.pageX - this.offsetX + this.scrollOfs.scrollLeft
        let endY = event.pageY - this.offsetY + this.scrollOfs.scrollTop
        this.tempRoute.path = `M ${startX} ${startY} T ${endX} ${endY}`
      },
      // 移动节点移动鼠标时重新设置节点位置
      moveNodeMove(event) {
        if (Math.abs(event.pageX - this.elePos.posX) < 1 || Math.abs(event.pageY - this.elePos.posY) < 1) {
          return
        }
        let newLeft = event.pageX - parseInt(this.curNode.size.width) / 2 - this.offsetX + this.scrollOfs.scrollLeft
        let newTop = event.pageY - parseInt(this.curNode.size.height) / 2 - this.offsetY + this.scrollOfs.scrollTop
        if (newLeft < 100) { // 边界判断
          newLeft = 100
        } else if (newLeft + parseInt(this.curNode.size.width) > parseInt(this.paperSize.width)) {
          newLeft = parseInt(this.paperSize.width) - parseInt(this.curNode.size.width)
        }
        if (newTop < 0) { // 边界判断
          newTop = 0
        } else if (newTop + parseInt(this.curNode.size.height) > parseInt(this.paperSize.height)) {
          newTop = parseInt(this.paperSize.height) - parseInt(this.curNode.size.height)
        }
        this.curNode.pos = {
          left: newLeft + 'px',
          top: newTop + 'px'
        }
      },
      // 鼠标弹起时：添加、移动节点或添加路由
      dragUp(event, create, item) {
        this.resetRoute()
        event.stopPropagation()
        this.isDrag = false
        if (this.dragType == 'add' && create) {
          this.addNodeUp()
        } else if (this.dragType == 'connect') {
          // 连接路由
          this.connectUp(item)
        } else if (this.dragType == 'move') {
          this.curEle = {}
        }
        if (this.curEle.type && this.curEle.type != 100) {
          this.curEle = {}
        }
        this.tempNode = {}
        this.dragType = ''
      },
      // 添加节点鼠标弹起，确定节点位置并加入节点数组
      addNodeUp() {
        this.tempNode.iden = this.nodeIden
        this.$emit('setNodeIden', this.nodeIden + 1)
        this.tempNode.size = {
          width: this.defaultSize[this.curEle.type / 10 - 1].width + 'px',
          height: this.defaultSize[this.curEle.type / 10 - 1].height + 'px'
        }
        // console.log('添加节点鼠标弹起，确定节点位置并加入节点数组', this.tempNode.size)
        this.$emit('setCurNode', this.tempNode)
        this.nodeList.push(this.tempNode)
        // 复制节点的信息
        this.$emit('modifyNodeList', this.nodeList)
      },
      // 连接路由鼠标弹起，绘制路由并加入路由数组数据
      connectUp(item) {
        // console.log("connectUp连接路由鼠标弹起，绘制路由并加入路由数组")
        let allowMul = (this.connectStartNode.type == this.TYPE_ONLY || this.connectStartNode.type == this.TYPE_MULTIPLE)   // 判断节点是否允许多路由（只有排他和并行网关才允许多路由）
        let isMul = _.findIndex(this.routeList, (res) => { // 该节点已存在以它为起始的路由
          return res.start_iden == this.connectStartNode.iden
        }) > -1
        let notSpecialNode = item.type != this.TYPE_START && item.type != this.TYPE_REMARK// 终结节点不是开始节点,不是备注节点
        let notBothStartAndEnd = this.tempRoute.start_iden != item.iden// 起始和终结不是同一个节点
        let notTwistConnect = _.findIndex(this.routeList, (res) => { // 没有反向连接
          return (res.start_iden == this.tempRoute.start_iden && res.end_iden == item.iden) ||
            (res.start_iden == item.iden && res.end_iden == this.tempRoute.start_iden)
        }) == -1
        if ((allowMul ||
          !allowMul && !isMul) &&
          notBothStartAndEnd &&
          notSpecialNode &&
          notTwistConnect) {  // 满足以上所有条件方可连接路由
          this.addVariable(item)
          this.addRoute(item)
        }
        this.connectStartNode = {}
        this.tempRoute = {}
      },
      // 为变量判断网关添加变量
      addVariable(item) {
        _(this.nodeList).forEach((res) => {
          if (res.type == this.TYPE_ONLY && this.tempRoute.start_iden == res.iden) {
            let is_default = res.variable.length ? 0 : 1
            let variable = {
              next_iden: item.iden,
              next_name: item.name,
              field_id: '',
              fixed_value: '',
              logic_type: 10,
              value_type: 10,
              is_default: is_default
            }
            res.variable.push(variable)
            return
          }
        })
      },
      // 添加新路由
      addRoute(item) {
        this.tempRoute.end_iden = item.iden
        let startX = this.tempRoute.start_x
        let startY = this.tempRoute.start_y
        let endPoint = this.getShortPoint(item, startX, startY)  // 获取最短距离
        this.tempRoute.end_x = endPoint[0]
        this.tempRoute.end_y = endPoint[1]
        let endX = this.tempRoute.end_x
        let endY = this.tempRoute.end_y
        this.tempRoute.path = `M ${startX} ${startY} T ${endX} ${endY}`
        this.routeList.push(this.tempRoute)
      },
      // 选择节点
      selectNode(item) {
        this.curEle = {}
      },
      // 移动节点时重绘相关路由
      redrawRoute() {
        _(this.routeList).forEach((item) => {
          if (item.end_iden == this.curNode.iden) { // 重绘路由尾为该节点的路由
            let endPoint = this.getShortPoint(this.curNode, item.start_x, item.start_y)
            item.end_x = endPoint[0]
            item.end_y = endPoint[1]
            let startIndex = _.findIndex(this.nodeList, (res) => {
              return res.iden == item.start_iden
            })
            let startPoint = this.getShortPoint(this.nodeList[startIndex], item.end_x, item.end_y)
            item.start_x = startPoint[0]
            item.start_y = startPoint[1]
            item.path = `M ${item.start_x} ${item.start_y} T ${item.end_x} ${item.end_y}`
          } else if (item.start_iden == this.curNode.iden) { // 重绘路由头为该节点的路由
            let startPoint = this.getShortPoint(this.curNode, item.end_x, item.end_y)
            item.start_x = startPoint[0]
            item.start_y = startPoint[1]
            let endIndex = _.findIndex(this.nodeList, (res) => {
              return res.iden == item.end_iden
            })
            let endPoint = this.getShortPoint(this.nodeList[endIndex], item.start_x, item.start_y)
            item.end_x = endPoint[0]
            item.end_y = endPoint[1]
            item.path = `M ${item.start_x} ${item.start_y} T ${item.end_x} ${item.end_y}`
          }
        })
      },
      // 点击路由出现删除按钮
      selectRoute(event, index, item) {
        this.curRouteIndex = index
        this.$emit('setCurRoute', item)
        this.delRouteBtn.show = true
        this.delRouteBtn.pos = {
          top: event.pageY - this.offsetY + this.scrollOfs.scrollTop + 'px',
          left: event.pageX - this.offsetX + this.scrollOfs.scrollLeft + 'px'
        }
      },
      // 确认删除节点弹窗
      confirmDeleteNode(event, item, index) {
        event.stopPropagation()
        this.delNode.node = item
        this.delNode.index = index
        this.delShow = true
      },
      // 双击事件
      dbclickEvent() {
        if (this.curNode.type == this.TYPE_REMARK ||
            this.curNode.type == this.TYPE_ONLY ||
            this.curNode.type == this.TYPE_MULTIPLE ||
            this.curNode.type == this.TYPE_FUNC ||
            this.curNode.type == this.TYPE_END) { // 无需配置控件的节点
          return
        }
        if (this.curNode.type == this.TYPE_CUD) { // CUD节点
          this.showCudConfig()
          return
        }
        this.showInputList()
      },
      // 显示cud配置
      showCudConfig() {
        this.$emit('setCudShow', true)
      },
      // 显示控件列表
      showInputList() {
        this.initInputStatus()
        this.$emit('setInputShow', true)
        setTimeout(() => {
          this.$emit('setCurNodeField', _.cloneDeep(this.curNode.field))
        }, 100)
      },
      // 编辑文本备注
      editRemark() {
        if (this.curNode.type != this.TYPE_REMARK) {
          return
        }
      },
      // 删除节点
      deleteNode() {
        _.remove(this.routeList, (item) => {
          let result = item.start_iden == this.delNode.node.iden || item.end_iden == this.delNode.node.iden
          if (result) {
            this.deleteVar(item)
          }
          return result
        })
        if (this.curNode.iden == this.nodeList[this.delNode.index].iden) {
          // 若当前选中节点为删除节点，则切换为选中开始节点
          this.$emit('setCurNode', this.nodeList[0])
        }
        if (this.curNode.type == this.TYPE_APPROVE) {
          this.$emit('getRelateNode')
        }
        this.nodeList.splice(this.delNode.index, 1)
        this.delNode = {}
        this.delShow = false
      },
      // 删除路由
      deleteRoute() {
        let startIden = this.routeList[this.curRouteIndex].start_iden
        this.deleteVar(this.routeList[this.curRouteIndex])
        this.routeList.splice(this.curRouteIndex, 1)
        if (startIden == this.curNode.iden) {
          this.$emit('getRelateNode')
        }
        this.resetRoute()
        this.curRouteIndex = -1
        this.$emit('setCurRoute', {})
        this.delRouteBtn.show = false
      },
      // 删除节点或路由时，删除相关的配置判断变量
      deleteVar(route) {
        _(this.nodeList).forEach((res) => {
          if (res.iden == route.start_iden && res.type == this.TYPE_ONLY) {
            _.remove(res.variable, (item) => {
              return item.next_iden == route.end_iden
            })
          }
        })
      },
      // 获取距离最近的点，作为连接点
      getShortPoint(item, posX, posY) {
        if (item.type >= 20 && item.type <= 50) { // 矩形和菱形 执行函数
          return this.getRectShortPoint(item, posX, posY)
        } else if (item.type == this.TYPE_START ||
                   item.type == this.TYPE_END ||
                   item.type === this.TYPE_FUNC ||
                   item.type == this.TYPE_CUD) { // 圆
          return this.getCircleShortPoint(item, posX, posY)
        }
      },
      // 获取矩形最短距离
      // posX, posY：基准点坐标
      // item：要计算的节点
      // 思路：计算（center, top)、（right, middle）,（bottom, center），（left, middle）四个点中哪个是离目标点最短的点
      getRectShortPoint(item, posX, posY) {
        let topPoint = [parseInt(item.pos.left) + parseInt(item.size.width) / 2, parseInt(item.pos.top)]
        let leftPoint = [parseInt(item.pos.left), parseInt(item.pos.top) + parseInt(item.size.height) / 2]
        let rightPoint = [parseInt(item.pos.left) + parseInt(item.size.width), parseInt(item.pos.top) + parseInt(item.size.height) / 2]
        let bottomPoint = [parseInt(item.pos.left) + parseInt(item.size.width) / 2, parseInt(item.pos.top) + parseInt(item.size.height)]
        let points = [topPoint, leftPoint, rightPoint, bottomPoint]
        let minDistance = -1
        let minIndex = -1
        _(points).forEach((item, index) => {
          let distance = this.getDistance(item, [posX, posY])
          if (minDistance == -1 || minDistance > distance) {
            minDistance = distance
            minIndex = index
          }
        })
        return points[minIndex]
      },
      // 思路：计算目标点与圆心的角度，利用三角函数求出该线段与圆周相交的交点
      getCircleShortPoint(item, posX, posY) {
        let center = [parseInt(item.pos.left) + parseInt(item.size.width) / 2, parseInt(item.pos.top) + parseInt(item.size.height) / 2]
        let angle = Math.atan((posY - center[1]) / (posX - center[0]))
        let radius = (parseInt(item.size.width)) / 2
        let minusX = Math.abs(radius * Math.cos(angle))
        let minusY = Math.abs(radius * Math.sin(angle))
        let pointX = center[0] > posX ? center[0] - minusX : center[0] + minusX
        let pointY = center[1] > posY ? center[1] - minusY : center[1] + minusY
        let point = [pointX, pointY]
        return point
      },
      // 计算直接距离
      getDistance(point1, point2) {
        return Math.pow(point1[0] - point2[0], 2) + Math.pow(point1[1] - point2[1], 2)
      },
      initInputStatus() {
        _(this.inputList).forEach((res) => {
          if (_.findIndex(this.curNode.field, (item) => {
            return res.default.field_id == item.field_id
          }) > -1) {
            res.selected = true
          } else {
            res.selected = false
          }
        })
      },
      // 设置当前节点的控件
      setCurNodeField(field) {
        this.curNode.field = field
      },
      hideInputList() {
        this.$emit('setInputShow', true)
      }
    },
    watch: {
      curNode() {
        if (this.curNode.type == this.TYPE_APPROVE) { // 审批节点需获取流向节点
          this.$emit('getRelateNode')
        }
      }
    },
    mixins: [modelConfig, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// nodePaper.vue?0554aa77